export const Tooltip = {
    baseStyle: {
        bg: "gray.900",
        color: "white",
        borderRadius: "10px",
        fontSize: "xs",
        py: 1,
        px: 2,
    },
};
